import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  CustomInput,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { INotificationAddReduxProps, INotificationAdd, ITarget, INotificationModel } from '../../types/interfaces';

import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { addNotificationmodel } from '../../flux/actions/notificationmodelActions';
import { getUsers } from '../../flux/actions/userActions';
import { getSocietes } from '../../flux/actions/societeActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckCircle, faCheckSquare, faExternalLinkAlt, faFileImage, faHandRock, faPen, faPlus, faSpinner, faSquare, faTimes, faTrash, faUsers } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";

import DatePicker from "reactstrap-date-picker";
import PhoneInput from "react-phone-input-2";
import frPhoneInput from 'react-phone-input-2/lang/fr.json'
import 'react-phone-input-2/lib/bootstrap.css'

import { useDropzone } from 'react-dropzone';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { constants } from '../../types/constants';

const NotificationAdd = ({
  modal,
  setModal,
  addNotificationmodel,
  // getUsers,
  user,
  getSocietes,
  societe,
  defaultType,
  defaultTitle,
  defaultDescription,
  defaultUsersIds,
  fromModal,
  auth
 }: INotificationAdd) => {
  const alert = useAlert();
  const {users, loading: loadingU} = user
  const { societes, loading: loadingS } = societe
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const societeOptions = societes.map(e => ({value: e, label: e.LIBELE}));
  const typeOptions = constants.NOTIFICATION_TYPES.map(e => ({value: e.code, label: e.label}));
  const [selectedType, setSelectedType] = useState<any>('');
  const [titleValue, setTitleValue] = useState('');
  const [descriptionValue, setDescriptionValue] = useState('');
  const [validFromValue, setValidFromValue] = useState('');
  const [validToValue, setValidToValue] = useState('');
  const [hideReceiversValue, setHideReceiversValue] = useState(false);
  const [privateValue, setPrivateValue] = useState(false);
  const [enabledValue, setEnabledValue] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
  const [commentValue, setCommentValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const [notificationImages, setNotificationImages] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*',
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setNotificationImages(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
    
  const handleToggle = () => setModal(!modal);

  // useEffect(() => getUsers(), [getUsers])
  
  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  const modalClosedHandle = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  useEffect(() => {
    if(defaultType){
      const typeData = constants.NOTIFICATION_TYPES.find(e => e.code === defaultType)
      if(typeData)
        setSelectedType({value: typeData.code, label: typeData.label})
    }
  }, [defaultType])

  useEffect(() => {
    if(defaultTitle)
      setTitleValue(defaultTitle)
  }, [defaultTitle])

  useEffect(() => {
    if(defaultDescription)
      setDescriptionValue(defaultDescription)
  }, [defaultDescription])

  useEffect(() => {
    if(defaultUsersIds?.length)
      setSelectedUsers(users.filter(e => defaultUsersIds.find(t => Number(t || 0) === e.id)))
  }, [defaultUsersIds])

  const handleTypeChange = data => {
    setSelectedType(data || '');
  }
  const titleChangeHandler = (e: ITarget) => setTitleValue(e.target.value);
  const descriptionChangeHandler = (e: ITarget) => setDescriptionValue(e.target.value);
  const validFromChangeHandler = (e, t) => {
    setValidFromValue(e);
  };
  const validToChangeHandler = (e, t) => {
    setValidToValue(e);
  };
  const changeEnabledHandle = (e) => {
    setEnabledValue(e.target.checked);
  };
  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Notification ajoutée avec succès");
      setSelectedType('');
      setTitleValue('');
      setDescriptionValue('');
      setValidFromValue('');
      setValidToValue('');
      setHideReceiversValue(false);
      setPrivateValue(false);
      setEnabledValue(true);
      setCommentValue('');
      
      setNotificationImages([]);
      setSelectedUsers([]);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const addHandle = async () => {
    if(selectedType === ''){
      alert.error("Veuillez sélectionner le type de la notification");
      return
    }
    if(titleValue === '' && descriptionValue === '' && !notificationImages?.length){
      alert.error("Veuillez saisir au moins un titre, une description ou une image");
      return
    }
    if(!selectedUsers?.length){
      alert.error("Veuillez sélectionner au moins un utilisateur");
      return
    }

    const notification : INotificationModel = {
      type: selectedType?.value || -1,
      title: titleValue || "",
      description: descriptionValue || "",
      validFrom: validFromValue ? new Date(validFromValue) : undefined,
      validTo: validToValue ? new Date(validToValue) : undefined,
      hideReceivers: hideReceiversValue ? 1 : 0,
      private: privateValue ? 1 : 0,
      enabled: enabledValue ? 1 : 0,
      comment: commentValue,
      createdById: auth?.user?.id,
      createdByName: auth?.user?.username,
    };
    setDisableSubmit(true);
    
    const imageCallback = (file: any = undefined) => addNotificationmodel(notification, selectedUsers.map(e => e.id), file, callback)

    if(notificationImages?.length){
      var reader = new FileReader();
      reader.onload = function() {
        var arrayBuffer = this.result,
          codedBuffer: string = "";
        (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
            codedBuffer += String.fromCharCode(byte);
        });
        imageCallback({codedBuffer});
      }
      reader.readAsArrayBuffer(notificationImages[0]);
    }
    else
      imageCallback()
  };

  return <>
    <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle} className={fromModal ? "modal-nested" : ""}>
      <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajout d'une nouvelle Notification</ModalHeader>
      <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label>Image</Label>
                  <section>
                    <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                      <input {...getInputProps()} />
                      {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                      {notificationImages?.length ? <aside className="thumbContainer">
                        {/* <div className="thumbEdit" onClick={e => (e.stopPropagation(), setImgToEdit({img: notificationImages?.length ? notificationImages[0].preview : null}), setCropModal(true))} title="Modifier le scan"><FontAwesomeIcon icon={faPen} style={{fontSize: "small"}} /></div> */}
                        <div className="thumbDelete" onClick={e => (e.stopPropagation(), setNotificationImages([]))} title="Supprimer l'image"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                        <div className="thumb" key={notificationImages[0].name}>
                          <div className="thumbInner">
                            <img src={notificationImages[0].preview} className="thumbImg" />
                          </div>
                        </div>
                      </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer une <span style={{fontWeight: 600}}>image</span> ici</span>}
                    </div>
                  </section>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="type" className="requiredLabel">Type</Label>
                  <Select
                    id="type"
                    name="type"
                    className="reactselect"
                    classNamePrefix="react-select"
                    // defaultValue={typeOptions[0]}
                    value={selectedType}
                    // value={{value: societeValue.value, label: societeValue.label}}
                    onChange={handleTypeChange}
                    isClearable={true}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={false}
                    options={typeOptions}                
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="title">Titre</Label>
                  <Input id="title" placeholder="Titre de la notification..." value={titleValue} onChange={titleChangeHandler} />
                  {!!selectedType?.value && <div className="text-muted">Si vous laissez ce champ vide, le texte par défaut affiché sera : {constants.NOTIFICATION_TYPES.find(e => e.code === selectedType?.value)?.label || "-"}</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="description">Déscription</Label>
                  <Input id="description" type="textarea" placeholder="Contenu de la notification..." value={descriptionValue} onChange={descriptionChangeHandler} style={{height: "110px"}} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="validFrom">Valide de</Label>
                  <DatePicker id="validFrom"
                    value={validFromValue}
                    dateFormat={constants.DP_DATE_FORMAT}
                    dayLabels={constants.DP_DAYS}
                    monthLabels={constants.DP_MONTHS}
                    weekStartsOn={constants.DP_WEEK_START}
                    onChange={(v,f) => validFromChangeHandler(v, f)} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="validTo">Fin de validité</Label>
                  <DatePicker id="validTo"
                    value={validToValue}
                    dateFormat={constants.DP_DATE_FORMAT}
                    dayLabels={constants.DP_DAYS}
                    monthLabels={constants.DP_MONTHS}
                    weekStartsOn={constants.DP_WEEK_START}
                    onChange={(v,f) => validToChangeHandler(v, f)} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup className="formCustomSwitch">
                  <Label for="hideReceivers" className="requiredLabel">Cacher les destinataires</Label>
                  <CustomInput type="switch" id="hideReceivers" name="hideReceiversSwitch" checked={hideReceiversValue} onChange={e => setHideReceiversValue(e.target.checked)} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup className="formCustomSwitch">
                  <Label for="private" className="requiredLabel">Privée</Label>
                  <CustomInput type="switch" id="private" name="privateSwitch" checked={privateValue} onChange={e => setPrivateValue(e.target.checked)} />
                  <div className="text-muted">Une notification privée ne peut pas être listée dans la page "Gestion des notifications" pour les autres utilisateurs, elle n'est visible que par son auteur.</div>
                </FormGroup>
              </Col>
            </Row>
            {/* <Row>
              <Col xs="12">
                <FormGroup className="formCustomSwitch">
                  <Label for="enabled" className="requiredLabel">Activée</Label>
                  <CustomInput type="switch" id="enabled" name="enabledSwitch" checked={enabledValue} onChange={changeEnabledHandle} />
                </FormGroup>
              </Col>
            </Row> */}
            <Label className="requiredLabel">Utilisateurs</Label>
            <Container className="CardInfo mb-2">
              <Row style={{padding: 0}}>
                <Col xs="12" md="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                      Par utilisateur
                    </Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={null}
                      onChange={e => setSelectedUsers(t => e?.value && !t.find(n => n.id === e.value.id) ? [...t, e.value] : t)}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      // labelKey='name'
                      // valueKey='countryCode'
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                    </FormGroup>
                </Col>
                <Col xs="12" md="6" style={{border: "none"}}>
                  <FormGroup>
                    <Label style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                      Par projet
                    </Label>
                    <Select
                      name="reactselect"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={null}
                      onChange={e => setSelectedUsers(t => {
                        const usersWithSameProject = userOptions.filter(n => n.value?.worksatProjects?.find(s => s.id === e.value.id) && !t.find(s => s.id === n.value?.id)).map(e => e.value)
                        return e?.value ? [...t, ...usersWithSameProject] : t
                      })}
                      placeholder={'Chercher par projet...'}
                      isClearable={false}
                      isLoading={loadingS}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      // labelKey='LIBELE'
                      // valueKey='code'
                      options={societeOptions}
                    />
                    </FormGroup>
                </Col>
              </Row>
              <div className="itemsListRow">
                {!!selectedUsers?.length && <Input placeholder="Filtrer..." value={searchValue} onChange={e => setSearchValue(e.target.value)} className="form-control-sm" />}
                {selectedUsers.filter(e => !searchValue || e.username?.toLowerCase().includes(searchValue.toLowerCase()) || e.given_name?.toLowerCase().includes(searchValue.toLowerCase()) || e.surname?.toLowerCase().includes(searchValue.toLowerCase())).map((e, key) => <div key={key} className="itemsListRowItem">
                  {e.username || "-"}
                  <FontAwesomeIcon icon={faTimes} className="itemsListRowItemClose" onClick={() => setSelectedUsers(t => t.filter(n => n.id !== e.id))} />
                </div>)}
                {!!searchValue && <div className="fullFlexCenter text-muted">{`+${selectedUsers.filter(e => !e.username?.toLowerCase().includes(searchValue.toLowerCase()) && !e.given_name?.toLowerCase().includes(searchValue.toLowerCase()) && !e.surname?.toLowerCase().includes(searchValue.toLowerCase())).length} autres`}</div>}
              </div>
              <div className="itemsListRowClear">
                <div className="itemsListRowClearDiv" style={{color: "darkgreen"}} onClick={() => setSelectedUsers(userOptions.map(e => e.value))}><FontAwesomeIcon icon={faUsers} />&nbsp;Sélectionner tout le monde</div>
                {!!selectedUsers?.length && <div className="itemsListRowClearDiv" onClick={() => setSelectedUsers([])}><FontAwesomeIcon icon={faTrash} />&nbsp;Effacer tout</div>}
              </div>
            </Container>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label for="comment">Commentaire <i>(pas visible dans la notification)</i></Label>
                  <Input id="comment" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
                </FormGroup>
              </Col>
            </Row>
            <Row className="justify-content-center stickyBottom">
              <Button
                className="btn btn-success linesConfirmationBtn"
                onClick={addHandle}
                disabled={disableSubmit}
                ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Diffuser</Button>
            </Row>
          </Container>
      </ModalBody>
    </Modal>
  </>
};

const mapStateToProps = (state: INotificationAddReduxProps) => ({
  user: state.user,
  societe: state.societe,
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { addNotificationmodel/*, getUsers*/, getSocietes })(NotificationAdd);
